import React from 'react'
import { useForm, FormContext } from 'react-hook-form'

import { Typography, Box, Button } from '@material-ui/core'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import useSnackbar from 'hooks/useSnackbar'

import { Card } from 'components'
import { PlanForm, ImplementForm, DecisionForm } from './components'

import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'
import schema from './schema'

import useStyles from './styles'

const PdcaCycleForm = ({
  setLoading,
  mode,
  dataPdcaCicle,
  refresh,
  pdcaId,
}) => {
  const history = useHistory()
  const snackbar = useSnackbar()
  const classes = useStyles()

  const isShow = mode === 'show'
  const isNew = mode === 'new'
  const modeRequest = isNew ? 'createCycle' : 'updateCycle'
  const rollbackRoute = isNew ? 'edit' : mode

  const handleReturn = () =>
    history.push(reverse(routes.pdca[rollbackRoute], { pdcaId }))
  const handleRedirectEdit = (pdcaCycleId) =>
    history.push(reverse(routes.pdca.editCycle, { pdcaId, pdcaCycleId }))

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      planWhat: dataPdcaCicle?.planWhat || '',
      planWhy: dataPdcaCicle?.planWhy || '',
      planWhere: dataPdcaCicle?.planWhere || '',
      planHow: dataPdcaCicle?.planHow || '',
      planHowMuch: dataPdcaCicle?.planHowMuch || '',
      planResources: dataPdcaCicle?.planResources || '',
      planWho: dataPdcaCicle?.planWho,
      planWhen: dataPdcaCicle?.planWhen
        ? new Date(dataPdcaCicle?.planWhen)
        : null,
      implementEvidence: dataPdcaCicle?.implementEvidence,
      implementRealization: dataPdcaCicle?.implementRealization
        ? new Date(dataPdcaCicle?.implementRealization)
        : null,
      decisionObservations: dataPdcaCicle?.decisionObservations,
      decisionExpectedDate: dataPdcaCicle?.decisionExpectedDate
        ? new Date(dataPdcaCicle?.decisionExpectedDate)
        : null,
      decisionFinishedDate: dataPdcaCicle?.decisionFinishedDate
        ? new Date(dataPdcaCicle?.decisionFinishedDate)
        : null,
    },
  })

  const { handleSubmit } = formMethods

  const toISO = (date) => (date ? date.toISOString() : null)

  const formattedData = (data) => ({
    ...data,
    planWhen: toISO(data?.planWhen),
    implementRealization: toISO(data?.implementRealization),
    decisionExpectedDate: toISO(data?.decisionExpectedDate),
    decisionFinishedDate: toISO(data?.decisionFinishedDate),
  })

  const onSubmit = async (data) => {
    if (isShow) return null
    setLoading(true)
    try {
      const response = await service.dponet.pdca[modeRequest]({
        pdcaId,
        pdcaCycleId: dataPdcaCicle?.id,
        ...formattedData(data),
      })
      snackbar.open({
        variant: 'success',
        message: isNew
          ? 'Ciclo de PDCA criado com sucesso.'
          : 'Ciclo de PDCA editado com sucesso.',
      })
      if (isNew) {
        if (response?.data) {
          handleRedirectEdit(response?.data?.monitoringManagementPdcaCycle?.id)
        }
      } else {
        return refresh()
      }
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          `Falha ao ${isNew ? 'criar' : 'editar'} PDCA.`,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title={isShow ? 'Ciclo de PDCA' : 'Formulário de ciclo do PDCA'}>
      <FormContext {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography variant="body2" className={classes.planTitle}>
            Planejar
          </Typography>
          <Box className={classes.plan}>
            <PlanForm isDisbled={isShow} formMethods={formMethods} />
          </Box>
          <Typography variant="body2" className={classes.executeTitle}>
            Executar
          </Typography>
          <Box className={classes.execute}>
            <ImplementForm isDisbled={isShow} formMethods={formMethods} />
          </Box>
          <Typography variant="body2" className={classes.decisionTitle}>
            Verificar/Agir
          </Typography>
          <Box className={classes.decision}>
            <DecisionForm isDisbled={isShow} formMethods={formMethods} />
          </Box>
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Box pr={1}>
              <Button type="button" variant="outlined" onClick={handleReturn}>
                Voltar
              </Button>
            </Box>
            {!isShow && (
              <Box>
                <Button color="primary" variant="contained" type="submit">
                  Salvar
                </Button>
              </Box>
            )}
          </Box>
        </form>
      </FormContext>
    </Card>
  )
}

export default PdcaCycleForm
